import FormBase from "../../forms/FormBase";
import PersonalDataForm from "../../forms/autorizacaoEspecial/PersonalDataForm";
import Professional from "../../models/Professional";
import { AutorizacaoEspecialStepForm } from "../../config/AutorizacaoEspecialStepForm";
import FormFieldBase from "../../forms/FormFieldBase";
import PatientForm from "../../forms/autorizacaoEspecial/PatientForm";
import ParticipationRequestForm from "../../forms/autorizacaoEspecial/ParticipationRequestForm";
import TermsDeclarationsForm from "../../forms/autorizacaoEspecial/TermsDeclarationsForm";
import { FieldAttachment } from "../../forms/FormFieldAttachmentBase";
import AttachmentForm from "../../forms/autorizacaoEspecial/AttachmentForm";
import GuideForm from "../../forms/shared/GuideForm";
import ReducerBase, { SubTypeAttachment } from "./ReducerBase";

export interface IAutorizacaoEspecialState {
  GuideForm: GuideForm;
  PersonalDataForm: PersonalDataForm;
  PatientForm: PatientForm;
  ParticipationRequestForm: ParticipationRequestForm;
  AttachmentForm: AttachmentForm;
  TermsDeclarationsForm: TermsDeclarationsForm;
  CurrentStep: number;
  MessageErrorToGoStep: string[];
  Loading: boolean;
  Professional: Professional;
  Protocol: string;
}

interface IUpdateForm {
  type: "UPDATE_FORM";
  payload: {
    form: FormBase;
    name: string;
    value: any;
  };
}

interface IUpdateFormAttachment {
  type: "UPDATE_FORM_ATTACHMENT";
  payload: {
    form: FormBase;
    name: string;
    value: FieldAttachment;
    errorMessage?: string;
    id?: string;
    loading?: boolean;
    subType: SubTypeAttachment;
  };
}

interface IGoToNextStep {
  type: "GO_TO_NEXT_STEP";
  payload: { messagesError: string[] };
}

interface IResetState {
  type: "RESET_STATE";
}

interface IGoToBackStep {
  type: "GO_TO_BACK_STEP";
}

interface IProcessingInfo {
  type: "LOADING";
  payload: { processing: boolean };
}
interface ISetProfessionalId {
  type: "SET_PROFESSIONAL";
  payload: {
    response: any;
  };
}
interface ISetProtocol {
  type: "SET_PROTOCOL";
  payload: {
    response: any;
  };
}

interface IClearErrorInput {
  type: "CLEAR_ERROR_INPUT";
  payload: {
    form: FormBase;
    name: string;
  };
}

export type Actions =
  | IUpdateForm
  | IGoToNextStep
  | IGoToBackStep
  | ISetProfessionalId
  | ISetProtocol
  | IProcessingInfo
  | IResetState
  | IUpdateFormAttachment
  | IClearErrorInput;

export const initialState: IAutorizacaoEspecialState = {
  GuideForm: GuideForm.NewInstance(),
  PersonalDataForm: PersonalDataForm.NewInstance(),
  ParticipationRequestForm: ParticipationRequestForm.NewInstance(),
  AttachmentForm: AttachmentForm.NewInstance(),
  PatientForm: PatientForm.NewInstance(),
  TermsDeclarationsForm: TermsDeclarationsForm.NewInstance(),
  CurrentStep: 1,
  MessageErrorToGoStep: [],
  Loading: false,
  Professional: Professional.NewInstance(),
  Protocol: "",
};

export const reducer = (state: IAutorizacaoEspecialState, action: Actions) => {
  switch (action.type) {
    case "UPDATE_FORM": {
      const { form, name, value } = action.payload;

      (form.GetFieldByName(name) as FormFieldBase).Value = value;
      (form.GetFieldByName(name) as FormFieldBase).InputChange(value);
      (form.GetFieldByName(name) as FormFieldBase).ValidateField();

      return { ...state };
    }

    case "UPDATE_FORM_ATTACHMENT": {
      const { form, name, value, subType, id, errorMessage, loading } = action.payload;

      ReducerBase.updateFileActions(form, name, value, subType, errorMessage, id, loading);

      return { ...state };
    }

    case "CLEAR_ERROR_INPUT": {
      const { form, name } = action.payload;

      (form.GetFieldByName(name) as FormFieldBase).Error = "";

      return { ...state };
    }

    case "SET_PROFESSIONAL": {
      const { response } = action.payload;

      let professional = new Professional(response.encriptId, response.name);

      return { ...state, Professional: professional };
    }

    case "SET_PROTOCOL": {
      const { response } = action.payload;

      return { ...state, Protocol: response.protocol };
    }

    case "GO_TO_NEXT_STEP": {
      const { messagesError } = action.payload;

      //Se houver mensagens de erro, não pode avançar a etapa
      if (messagesError.length === 0) {
        if (state.CurrentStep < AutorizacaoEspecialStepForm.length) {
          return {
            ...state,
            CurrentStep: state.CurrentStep + 1,
            MessageErrorToGoStep: [],
          };
        }
      } else {
        return { ...state, MessageErrorToGoStep: messagesError };
      }

      return { ...state };
    }

    case "GO_TO_BACK_STEP":
      if (state.CurrentStep > 1) {
        return {
          ...state,
          CurrentStep: state.CurrentStep - 1,
          MessageErrorToGoStep: [],
        };
      }
      return { ...state };

    case "LOADING":
      const { processing: loading } = action.payload;

      return { ...state, Loading: loading };

    case "RESET_STATE":

      return {
        ...state,
        GuideForm: GuideForm.NewInstance(),
        PersonalDataForm: PersonalDataForm.NewInstance(),
        ParticipationRequestForm: ParticipationRequestForm.NewInstance(),
        AttachmentForm: AttachmentForm.NewInstance(),
        PatientForm: PatientForm.NewInstance(),
        TermsDeclarationsForm: TermsDeclarationsForm.NewInstance(),
        CurrentStep: 1,
        MessageErrorToGoStep: [],
        Loading: false,
        Professional: Professional.NewInstance(),
        Protocol: "",
      };

    default:
      return { ...state };
  }
};

export function getStateFormPropertyByName(
  name: string,
  state: IAutorizacaoEspecialState
): any {
  switch (name) {
    case "GuideForm":
      return state.GuideForm;
    case "PersonalDataForm":
      return state.PersonalDataForm;
    case "PatientForm":
      return state.PatientForm;
    case "ParticipationRequestForm":
      return state.ParticipationRequestForm;
    case "TermsDeclarationsForm":
      return state.TermsDeclarationsForm;
    case "AttachmentForm":
      return state.AttachmentForm;
    default:
      console.error(`O Formulário ${name} não está mapeando no reducer`);
      break;
  }
}
